/**
 * 테이블 헤더 데이터 컨버터
 */
export default class DataTableHeaderConverter {
    /** 헤더 데이터 */
    header = [];
    /** 정렬 방식 */
    sort = {};
    /** 셀 너비 */
    cellWidth = [];
    /** 셀 정렬 방식 */
    cellAlign = [];
    /** 본문 키 리스트 */
    bodyKeyList = [];
    /**
     * 합계가 사용되는 키 리스트 [{ key: 'key1', method: 'sum' }, { key: 'key2', method: 'average' }, { key: '', method: '' }]
     * 합계가 사용되지 않는 경우 빈 문자열로 처리
     */
    totalKeyList = [];
    constructor(header) {
        this.header = header;
        this.header.forEach((item) => {
            // sort 로직
            if (item.sortLogic) {
                this.sort[item.value] = item.sortLogic;
            }
            // 셀 너비
            if (item.width) {
                this.cellWidth.push({
                    width: `${item.width}px`,
                });
            }
            // 자식 요소도 채크해야 하는 케이스
            if (item.children) {
                item.children.forEach((child) => {
                    this.cellAlign.push(child.cellAlign);
                    this.bodyKeyList.push(child.value);
                    this.totalKeyList.push(child.isTotal ? {
                        key: child.value,
                        method: child.isTotal,
                    } : null);
                });
            }
            else {
                this.cellAlign.push(item.cellAlign);
                this.bodyKeyList.push(item.value);
                this.totalKeyList.push(item.isTotal ? {
                    key: item.value,
                    method: item.isTotal,
                } : null);
            }
        });
    }
}
